import {
  type ScreeningSurveyStatusResponse,
  ScreeningSurveyStatusResponseSchema,
} from "@clipboard-health/contract-home-health-api";
import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { type z } from "zod";

import { IN_HOME_APP_EVENTS } from "../../lib/events";

function getScreeningSurveyStatusUrl(workerId: string) {
  return `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workers/${workerId}/screening-surveys/status`;
}

export function getScreeningSurveyStatusQueryKey(workerId: string) {
  return [getScreeningSurveyStatusUrl(workerId)];
}

export function useGetScreeningSurveyStatus(
  workerId: string,
  options?: UseGetQueryOptions<ScreeningSurveyStatusResponse>
) {
  const url = getScreeningSurveyStatusUrl(workerId);

  return useGetQuery({
    url,
    responseSchema:
      // ZodEffects transforms (for requiredEnumWithFallback and dateTimeSchema) require z.ZodType<T> assertions
      ScreeningSurveyStatusResponseSchema as z.ZodType<ScreeningSurveyStatusResponse>,
    meta: {
      logErrorMessage: IN_HOME_APP_EVENTS.SCREENING_SURVEY_STATUS_FETCH_FAILED,
    },
    enabled: isDefined(workerId),
    ...options,
  });
}
